import {BaseEntity} from "./BaseEntity";

export class Reader implements BaseEntity {
    constructor(
        public id?:number,
        public name?:string,
        public readerModel:string="Alien",
        public radsModeEnabled?:boolean,
        public port:string="",
        public username: string = "",
        public password: string = "",
        public ipAddress='10.10.10.10',
        public deviceSettings?:string,
        public connectionStatus?:string,
        public useWithService?:string,
        public physicalID?:string,
        public lastSeen?:string,
        public locationID?:number,
        public assetMovedAlertingActionID?:number,
        public securityIndicationAlertingActionID?:number,
        public lowBatteryAlertingActionID?:number,
        public sensorThresholdAlertingActionID?:number,
        public innerDirectionAlertingActionID?:number,
        public outerDirectionAlertingActionID?:number,
        public readerDisconnectedAlertingActionID?:number,
        public mapSiteID?:number,
        public vTagX?:number,
        public vTagY?:number,
        public vTagZ?:number,
        public vTagGpsGatewayID?:string,
        public lastModifiedBy?: string,
        public mqttControlTopic?:string,
        public updateLocation:boolean = false,
        public updateLastInventoried:boolean = false) { }

    parseJson(json: any): void {
        this.id = json.id
        this.name = json.name;
        this.readerModel = json.readerModel;
        this.radsModeEnabled=json.radsModeEnabled;
        this.port = json.port;
        this.ipAddress = json.ipAddress;
        this.username = json.username;
        this.password = json.password;
        this.deviceSettings = json.deviceSettings;
        this.connectionStatus = json.connectionStatus;
        this.useWithService = json.useWithService;
        this.physicalID = json.physicalID;
        this.lastSeen = json.lastSeen;
        this.locationID = json.locationID;
        this.assetMovedAlertingActionID = json.assetMovedAlertingActionID;
        this.securityIndicationAlertingActionID = json.securityIndicationAlertingActionID;
        this.lowBatteryAlertingActionID = json.lowBatteryAlertingActionID;
        this.sensorThresholdAlertingActionID = json.sensorThresholdAlertingActionID;
        this.innerDirectionAlertingActionID  = json.innerDirectionAlertingActionID;
        this.outerDirectionAlertingActionID = json.outerDirectionAlertingActionID;
        this.innerDirectionAlertingActionID = json.innerDirectionAlertingActionID;
        this.readerDisconnectedAlertingActionID = json.readerDisconnectedAlertingActionID;
        this.mapSiteID = json.mapSiteID;
        this.vTagX = json.vTagX;
        this.vTagY = json.vTagY;
        this.vTagZ = json.vTagZ;
        this.lastModifiedBy = json.lastModifiedBy;
        this.vTagGpsGatewayID = json.vTagGpsGatewayID;
        this.mqttControlTopic = json.mqttControlTopic;
        this.updateLocation = json.updateLocation;
        this.updateLastInventoried = json.updateLastInventoried;
    }

    search(txt:string):boolean{
        if(txt == null || txt.length == 0)
            return true;
        var search:string = txt.toLowerCase();
        if(this.name != null && this.name.toLowerCase().indexOf(search) != -1)
            return true;
        return false;
    }

    isActive(minutes:number){
        var nowDate:number = Date.now();
        var lastSeenDate:number = this.lastSeen == null ? Date.now() : Date.parse(this.lastSeen);
        var diffDate:number = nowDate - lastSeenDate;
        var diffMinutes:number = Math.abs(diffDate /60000);
        if(diffMinutes > minutes)
            return false;
        else
            return true;
    }

    isRecentlyActive(){
        var nowDate:number = Date.now();
        var lastSeenDate:number = this.lastSeen == null ? null : Date.parse(this.lastSeen);
        if(lastSeenDate === null)
            return false;
        var diffDate:number = nowDate - lastSeenDate;
        var diffMinutes:number = Math.abs(diffDate /60000);
        if(diffMinutes < 30)
            return true;
        else
            return false;
    }

}
